import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import Constants from '../../../../utils/Constants';
import ScrollAnimation from '../../../../utils/ScrollAnimation';
import variables from '../../../../style/variables.scss';
import HallsList from './HallsList';

const Halls = () => {
  const imgRef = useRef<Slider>(null);
  const textRef = useRef<Slider>(null);
  const transitionSpeed: number = 500;

  const [activeSlide, setActiveSlide] = useState<number>(0);

  const next = () => {
    imgRef.current?.slickNext();
    textRef.current?.slickNext();
  };

  const prev = () => {
    imgRef.current?.slickPrev();
    textRef.current?.slickPrev();
  };

  useEffect(() => {
    setActiveSlide(0);
  }, []);

  const slickImg = {
    adaptiveHeight: false,
    draggable: false,
    swipe: false,
    arrows: false,
    fade: true,
    infinite: true,
    speed: transitionSpeed,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const slickText = {
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 870,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
    draggable: false,
    swipe: false,
    arrows: false,
    fade: true,
    infinite: true,
    speed: transitionSpeed,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current: number, next: number) => {
      setActiveSlide(next);
    },
  };

  return (
    <div id={Constants.MICE_HALLS} className='miceComponents'>
      <div className='miceComponents_container container'>
        <ScrollAnimation animateIn='fadeIn' animateOut='fadeOut' duration={100}>
          <ScrollAnimation animateIn='fadeInUp' duration={500} dellay={100}>
            <h2 className='text_center'>TAKE YOUR MEETINGS TO ANOTHER LEVEL</h2>
            <p>
              Whether you are hosting an intimate private gathering or a
              corporate event, we have the perfect downtown venues for you. Any
              special occasion can be arranged in a variety of different
              settings, indoors or on our beautiful open terraces.
            </p>
            <ul className='miceComponents_container_content_list'>
              <li>Air conditioning</li>
              <li>Conference setting</li>
              <li>High-speed Wi-Fi</li>
              <li>LCD TVs</li>
              <li>Laptop</li>
              <li>Projector + Pointer</li>
              <li>Projection screen</li>
              <li>Microphone</li>
              <li>Flipchart</li>
              <li>Simultaneous translation services</li>
            </ul>
          </ScrollAnimation>
          <div className='miceComponents_container_content'>
            <ScrollAnimation animateIn='fadeInUp' dellay={150}>
              <div className='miceComponents_container_content_text'>
                <Slider ref={textRef} {...slickText}>
                  {HallsList.map((feature) => (
                    <>{feature.description}</>
                  ))}
                </Slider>
                <div className='miceComponents_container_content_buttons'>
                  <div
                    className='opacity_transition_low'
                    onClick={() => prev()}
                  >
                    {Constants.arrowLeft(variables.secondaryColor)}
                  </div>
                  <div
                    className='opacity_transition_low'
                    onClick={() => next()}
                  >
                    {Constants.arrowRight(variables.secondaryColor)}
                  </div>
                  <div className='miceComponents_container_content_buttons_counter'>
                    {activeSlide + 1} / {HallsList.length}
                  </div>
                </div>
              </div>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeIn' dellay={200}>
              <div className='miceComponents_container_content_img'>
                <Slider ref={imgRef} {...slickImg}>
                  {HallsList.map((feature) => (
                    <img
                      src={feature.imgPath}
                      alt={`${Constants.MICE_HALLS} ${
                        HallsList[HallsList.indexOf(feature)]
                      }`}
                    />
                  ))}
                </Slider>
              </div>
            </ScrollAnimation>
          </div>
        </ScrollAnimation>
      </div>
    </div>
  );
};

export default Halls;
